import React, { useState, useEffect } from 'react';
import NameTypewriter from './NameTypewriter';
import Navigation from './Navigation';

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Check if we've scrolled past the header content
      if (window.scrollY > 200) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Cleanup event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header style={styles.header}>
      <NameTypewriter />
      <div style={{
        ...styles.navContainer,
        ...(isSticky ? styles.sticky : {}),
      }}>
        <Navigation />
      </div>
    </header>
  );
};

const styles = {
  header: {
    padding: '2rem 1rem',
    textAlign: 'center',
    position: 'relative',
    marginBottom: '2rem',
  },
  navContainer: {
    padding: '1rem 0',
    transition: 'all 0.3s ease',
    zIndex: 1000,
  },
  sticky: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 2px 10px rgba(255, 0, 255, 0.2)',
    borderBottom: '1px solid rgba(255, 0, 255, 0.3)',
    padding: '0.5rem 0',
  }
};

export default Header; 